import ContentContainer from '@components/ContentContainer';

const TeamSettingsPage = () => {
  return <ContentContainer>TeamSettingsPage</ContentContainer>;
};

export default TeamSettingsPage;
